export type ErrorClass = "user" | "system" | "ambient";

export interface AppError {
  class: ErrorClass;
  code: string;
  userMessage: string;
  cause?: unknown;
}

export function isAppError(err: unknown): err is AppError {
  return (
    typeof err === "object" &&
    err !== null &&
    "class" in err &&
    "code" in err &&
    "userMessage" in err
  );
}

/** Wrap any thrown value into a typed AppError */
export function classifyError(err: unknown, fallbackCode: string): AppError {
  if (isAppError(err)) return err;

  const message = err instanceof Error ? err.message : String(err);

  if (
    message.includes("invalid") ||
    message.includes("expired") ||
    message.includes("not found")
  ) {
    return { class: "user", code: fallbackCode, userMessage: message, cause: err };
  }

  if (message.includes("NetworkError") || message.includes("fetch")) {
    return {
      class: "ambient",
      code: "NETWORK_UNAVAILABLE",
      userMessage: "Something didn't reach us — try once more.",
      cause: err,
    };
  }

  return {
    class: "system",
    code: fallbackCode,
    userMessage: "Something stopped — we've been notified.",
    cause: err,
  };
}
